var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWeatherWindyBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.6c-.4415 0-.8435.1576-1.1568.4208-.4228.3552-1.0536.3004-1.4089-.1224-.3552-.4229-.3004-1.0537.1225-1.409A3.7888 3.7888 0 0110 1.6c2.0987 0 3.8 1.7013 3.8 3.8S12.0987 9.2 10 9.2H4.2c-.5523 0-1-.4477-1-1s.4477-1 1-1H10c.9941 0 1.8-.806 1.8-1.8 0-.9941-.8059-1.8-1.8-1.8z",
    fill: "#24272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 7.2c-.4415 0-.8435.1576-1.1568.4208-.4228.3552-1.0536.3004-1.4089-.1225-.3552-.4228-.3004-1.0536.1225-1.4089A3.7885 3.7885 0 0118.2 5.2C20.2987 5.2 22 6.9014 22 9c0 2.0987-1.7013 3.8001-3.8 3.8001H2c-.5523 0-1-.4478-1-1 0-.5523.4477-1 1-1h16.2c.9941 0 1.8-.806 1.8-1.8 0-.9942-.8059-1.8-1.8-1.8zM12.4432 19.5792A1.7887 1.7887 0 0013.6 20c.9941 0 1.8-.8059 1.8-1.8 0-.9941-.8059-1.8-1.8-1.8H4.2c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.4c2.0987 0 3.8 1.7013 3.8 3.8S15.6987 22 13.6 22a3.7884 3.7884 0 01-2.4432-.8895c-.4229-.3552-.4777-.986-.1225-1.4089.3553-.4229.9861-.4777 1.4089-.1224z",
    fill: "#24272A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherWindyBlack);
export default __webpack_public_path__ + "static/media/Icon-Weather-Windy-Black.0acd4ba21e1adf28a55cddee144ea223.svg";
export { ForwardRef as ReactComponent };